// This file exports image paths for use throughout the application
// In a real application, these would be actual image imports

// Hero and background images
export const heroImage = '/images/AdobeStock_1119067506.jpeg';
export const aboutImage = '/images/AdobeStock_435786573.jpeg';

// Service images
export const djServicesImage = '/images/AdobeStock_930062517.jpeg';
export const djServicesDetailImage = '/images/AdobeStock_890638792.jpeg';
export const audioSolutionsImage = '/images/AdobeStock_443459843.jpeg';
export const speakersImage = '/images/AdobeStock_316592758.jpeg';
export const audioSolutionsDetailImage = '/images/brown_speakers.png';
export const lightingProductionImage = '/images/AdobeStock_485459956.jpeg';
export const lightingProductionDetailImage = '/images/AdobeStock_694346733.jpeg';
export const audioInstallationImage = '/images/AdobeStock_316592758.jpeg';
export const vinylSalesImage = '/images/AdobeStock_905240137.jpeg';

// Logo
export const logoImage = '/images/logo.png';
export const logoLimeImage = '/images/logo-lime.png';
export const logoWhiteImage = '/images/logo-white.png';
export const logoWhiteSimpleImage = '/images/logo-white-simp.png';

// Gallery images
export const galleryImages = [
  '/images/AdobeStock_802792979.jpeg',
  '/images/AdobeStock_890638792.jpeg',
  '/images/AdobeStock_435786573.jpeg',
  '/images/AdobeStock_1105917221.jpeg',
  '/images/AdobeStock_962215754.jpeg',
  '/images/AdobeStock_694346733.jpeg']; 